import React, { useEffect, useState } from 'react';
import { Switch as HSwitch } from '@headlessui/react';
import cx from 'classnames';

interface SwitchProps {
  checked?: boolean;
  onChange?: (state?: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Switch({
  checked = false,
  onChange = () => {},
  size = 'md',
  disabled = false,
  className,
  ...props
}: SwitchProps) {
  const [enabled, setEnabled] = useState<boolean>(checked);

  useEffect(() => {
    setEnabled(checked);
  }, [checked]);

  return (
    <HSwitch
      checked={enabled}
      disabled={disabled}
      onChange={(e: boolean) => {
        onChange(e);
        setEnabled(e);
      }}
      className={cx('toggle-switch', className && className, {
        'w-[24px] h-[12px]': size === 'sm',
        'w-[32px] h-[16px]': size === 'md',
        'w-[44px] h-[22px]': size === 'lg',
      })}
      {...props}
    >
      <span
        aria-hidden="true"
        className={cx(
          'toggle-switch-knob',
          enabled
            ? size === 'sm'
              ? 'translate-x-[12px]'
              : size === 'md'
              ? 'translate-x-[16px]'
              : 'translate-x-[22px]'
            : 'translate-x-0',
          {
            'w-[8px] h-[8px]': size === 'sm',
            'w-[12px] h-[12px]': size === 'md',
            'w-[18px] h-[18px]': size === 'lg',
          }
        )}
      />
    </HSwitch>
  );
}
